import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../state/actions'
import { bindActionCreators } from 'redux'
import { Link, browserHistory } from 'react-router'
import { Alert } from 'react-bootstrap'
import List from './../common/List'
import Navigation from './../common/Navigation'

class Apps extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataColumnsNames: [
                'Name', 'Actions'
            ],
            notification: {
                data: null,
                status: null
            },
            loading: false
        };
    }

    appSelect(app, e) {
        var self = this;
        self.props.actions.appSelect(app).then(function(){
            browserHistory.push('/manager/' + app.codename + '/dashboard');
        });
        if (e) { e.preventDefault(); }
    }

    editApp(appId) {
        var self = this;
        self.props.actions.appCleanOne().then(function(){
            browserHistory.push('/manager/app/edit/' + appId);
        });
    }

    goAccounts(appCodename) {
        var self = this;
        self.props.actions.appCleanOne().then(function(){
            browserHistory.push('/manager/account/'+appCodename);
        });
    }

    appReset(appCodename) {
        var self = this;
        var appsList = self.refs.Apps.getWrappedInstance();
        return appsList.openModal({
            title: 'Reset app',
            description: 'Are you sure you want to reset this app?',
            button: {
                cancel: {
                    title: 'Cancel',
                    className: 'btn-default'
                },
                success: {
                    title: 'Reset',
                    className: 'btn-danger',
                    onClick: self.confirmResetApp,
                    onClickBind: self
                },
                moreButtons: [
                    {
                        title: 'Reset with stats',
                        className: 'btn-danger',
                        onClick: self.confirmResetAppWithStats,
                        onClickBind: self
                    }
                ]
            }
        }, {
            appCodename: appCodename
        });
    }

    appNewToken(appCodename) {
        var self = this;
        var appsList = self.refs.Apps.getWrappedInstance();
        return appsList.openModal({
            title: 'Nuevo token',
            description: 'Are you sure you want to create a new token for this app?\nPrevious token will stop working.',
            button: {
                cancel: {
                    title: 'Cancel',
                    className: 'btn-default'
                },
                success: {
                    title: 'Create new token',
                    className: 'btn-danger',
                    onClick: self.confirmNewTokenApp,
                    onClickBind: self
                }
            }
        }, {
            appCodename: appCodename
        });
    }

    confirmResetApp(metadata) {
        var self = this;
        var appsList = self.refs.Apps.getWrappedInstance();
        self.props.actions.appReset(metadata.appCodename).then(function() {
            return appsList.refreshData(true);
        }).then(function() {
            return appsList.closeModal();
        });
    }

    confirmResetAppWithStats(metadata) {
        var self = this;
        var appsList = self.refs.Apps.getWrappedInstance();
        self.props.actions.appReset(metadata.appCodename, { stats: true }).then(function() {
            return appsList.refreshData(true);
        }).then(function() {
            return appsList.closeModal();
        });
    }

    confirmNewTokenApp(metadata) {
        var self = this;
        var appsList = self.refs.Apps.getWrappedInstance();
        var newToken = null
        self.props.actions.appNewToken(metadata.appCodename).then(function(data) {
            if (data.payload && data.payload.data && data.payload.data.token) {
                newToken = data.payload.data.token
            }
            return appsList.closeModal();
        }).then(function() {
            if (newToken) {
                return appsList.openModal({
                    title: 'New token',
                    description: 'New token is: ' + newToken,
                    button: {
                        cancel: {
                            title: 'Close',
                            className: 'btn-default'
                        }
                    }
                })
            }
        })
    }

    appDelete(appId) {
        var self = this;
        var appsList = self.refs.Apps.getWrappedInstance();
        return appsList.openModal({
            title: 'Delete app',
            description: '¿Está seguro que desea Delete esta app?',
            button: {
                cancel: {
                    title: 'Cancel',
                    className: 'btn-default'
                },
                success: {
                    title: 'Delete',
                    className: 'btn-danger',
                    onClick: self.confirmDeleteApp,
                    onClickBind: self
                }
            }
        }, {
            appId: appId
        });
    }

    confirmDeleteApp(metadata) {
        var self = this;
        var appsList = self.refs.Apps.getWrappedInstance();
        self.props.actions.appDelete(metadata.appId).then(function() {
            return appsList.refreshData(true);
        }).then(function() {
            return appsList.closeModal();
        });
    }

    clearNotification() {
        var self = this;
        self.setState({
            notification: {
                data: null,
                status: null
            }
         })
    }

    dataObjectProcess(app) {
        var self = this;
        var row = [];
        row.push(
            <a href={ "/manager/" + app.codename + "/dashboard" } onClick={ self.appSelect.bind(self, app) }>{ app.name }</a>
        );
        row.push(
            <div>
                <button type="button" className="btn btn-primary" onClick={self.editApp.bind(self, app._id)}>Edit</button>
                &nbsp;
                <button type="button" className="btn btn-primary btn-danger" onClick={self.appDelete.bind(self, app._id)}>Delete</button>
            </div>
        );
        return row;
    }

    render() {
        var self = this;
        var content;

        var itemsProcessed = [];
        if (self.props.apps) {
            self.props.apps.objects.forEach(function(app) {
                itemsProcessed.push(self.dataObjectProcess(app));
            });
        }

        var listHeader =
        <div className="row">
            <div className="col-sm-12">
                <Link className="btn btn-primary" to={'/manager/app/add'}>Add App</Link>
            </div>
            &nbsp;
        </div>

        return (
            <div>
                <Navigation title="Superadmin" />
                {(this.state.notification.data && this.state.notification.status) && <Alert bsStyle={this.state.notification.status} onDismiss={self.clearNotification.bind(self)}>
                    <strong>{ this.state.notification.data }</strong>
                </Alert>}
                <div className="container">
                    <List
                        ref="Apps"
                        items={itemsProcessed}
                        name="Apps"
                        dataColumnsNames={self.state.dataColumnsNames}
                        description={<span>Apps list</span>}
                        listHeader={listHeader}
                        getObjects={self.props.actions.appGet.bind(this, { sort: { name: 1 }})}
                        clearObjects={self.props.actions.appClean.bind(this)}
                        limit={ 100 }
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        apps: state.apps,
        routing: state.routing
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Apps)



// WEBPACK FOOTER //
// ./components/Apps/index.js